const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Overview Content Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Analyze the resource defined to get Analyze data
 * @argument {Resource} Overview the resource defined to get Overview queries
 */
app.controller('overviewPollsController', ['Authorization', function (Authorization) {
    var self = this;

    self.isAdmin = function () {
      return Authorization.getAuthToken() && Authorization.getAuthToken().user && Authorization.getAuthToken().user.role === 'admin';
    };

  }]);